<template>
  <div class="comp-fh-divider">
    <div class="divider-title">系统字段</div>
    <hr class="divider-line" />
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue';
console.log('1-开始创建组件-setup');
const data = reactive({});
const name = ref();
console.log(data, name);
</script>
<style scoped lang="less">
@import './fh-divider.less';
</style>
